/* MUSE & MAKER - mm-piece-card.js, 28 Sep 2026. THE CARD'S BEHAVIOUR, one copy.
   Loaded by sections/mm-piece-index.liquid and sections/mm-piece-row.liquid,
   which both render snippets/mm-piece-card.liquid inside a root with the id
   "mmpi". Lifted out of the grid section on 28 Sep so the homepage row and
   the Furniture door share it (Clara: the homepage cards must be a copy).
   DESKTOP (hover + fine pointer): hover a size chip and the card shows that
   size's own white render. image_tag writes a srcset, so it MUST come off
   before src is set or the browser keeps serving the front picture at most
   widths; the original src, srcset and sizes are kept and put back on
   mouseleave. The chips' renders are warmed on first mouseenter.
   TABLET (no hover, 38em and up): the first tap on a card with sizes opens
   its chips instead of following the link; the second tap follows.
   PHONES are handled by assets/mm-piece-sheet.js, not here. */
(function(){
  function init(){
    var root=document.getElementById('mmpi');
    if(!root||root.hasAttribute('data-mm-card'))return;
    root.setAttribute('data-mm-card','1');
    var cards=root.querySelectorAll('.mmpi__card');

    if(window.matchMedia('(hover:hover) and (pointer:fine)').matches){
      cards.forEach(function(card){
        var img=card.querySelector('.mmpi__img');
        var szs=card.querySelectorAll('.mmpi__sz');
        if(!img||!szs.length)return;
        var baseSrc=img.getAttribute('src');
        var baseSet=img.getAttribute('srcset');
        var baseSizes=img.getAttribute('sizes');
        var warmed=false;
        function warm(){
          if(warmed)return;
          warmed=true;
          szs.forEach(function(a){
            var u=a.getAttribute('data-img');
            if(u){var i=new Image();i.src=u;}
          });
        }
        function settle(){card.classList.remove('is-fading');}
        function show(a){
          var u=a.getAttribute('data-img');
          if(!u)return;
          szs.forEach(function(b){b.classList.toggle('is-showing',b===a);});
          card.classList.add('is-size');
          if(img.getAttribute('src')===u)return;
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          card.classList.add('is-fading');
          img.onload=settle;
          img.onerror=settle;
          img.src=u;
        }
        function reset(){
          card.classList.remove('is-size');
          card.classList.remove('is-fading');
          szs.forEach(function(b){b.classList.remove('is-showing');});
          if(img.getAttribute('src')===baseSrc)return;
          img.onload=null;
          img.onerror=null;
          img.src=baseSrc;
          if(baseSet){img.setAttribute('srcset',baseSet);}
          if(baseSizes){img.setAttribute('sizes',baseSizes);}
        }
        card.addEventListener('mouseenter',warm);
        card.addEventListener('mouseleave',reset);
        szs.forEach(function(a){
          a.addEventListener('mouseenter',function(){show(a);});
          a.addEventListener('focus',function(){warm();show(a);});
        });
      });
    }

    if(window.matchMedia('(hover:none) and (min-width:38em)').matches){
      cards.forEach(function(card){
        if(!card.classList.contains('has-sizes'))return;
        var hit=card.querySelector('.mmpi__hit');
        if(!hit)return;
        hit.addEventListener('click',function(e){
          if(!card.classList.contains('is-open')){
            e.preventDefault();
            cards.forEach(function(c){c.classList.remove('is-open');});
            card.classList.add('is-open');
          }
        });
      });
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();